import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  call,
} from '../../lib'
import {doREQUEST_ERROR, doREQUEST_COMPLETE, doMETHOD_SET, doPENDING_REQUEST_DELETE, doREQUEST_SKIP} from '../state'
import {checkRequestPending} from './check_pending_request'
import {getToken} from './token_fetcher'

export const REQUEST_METHOD_FETCH = 'REQUEST_METHOD_FETCH'
export const doREQUEST_METHOD_FETCH = createDoRequestAction(REQUEST_METHOD_FETCH)

export const requestMethodFetchActionCreators = {
  doREQUEST_METHOD_FETCH,
}

export function* requestMethodFetch({payload, setRequestResult}: any): SagaIterator {
  debug('saga*requestMethodFetch')

  const sameRequestPending = yield call(checkRequestPending, REQUEST_METHOD_FETCH, payload)
  if (sameRequestPending === true) {
    return yield put(
      doREQUEST_SKIP({
        fromType: REQUEST_METHOD_FETCH,
        requestId: payload.requestId,
      }),
    )
  }

  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        methodId: v.string().uuid().exist(),
      }),
    })
  } catch (error) {
    yield put(doPENDING_REQUEST_DELETE({requestType: REQUEST_METHOD_FETCH, requestId: payload.requestId}))
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_METHOD_FETCH,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    )
  }

  const {methodId} = payload

  const accessToken = yield call(getToken)

  const result = yield request({
    method: 'post',
    url: `${API_URL}/v1/web/method-fetch`,
    accessToken,
    data: {
      methodId,
    },
  })

  if (!result.success || result.error) {
    const error = result.error || new Error('request did not succeed')
    debug(error)
    yield put(doPENDING_REQUEST_DELETE({requestType: REQUEST_METHOD_FETCH, requestId: payload.requestId}))

    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_METHOD_FETCH,
          fromPayload: payload,
          requestId: payload.requestId,
          url: '/v1/web/method-fetch',
          ...result,
          error,
        },
        setRequestResult,
      ),
    )
  }

  yield put(doMETHOD_SET(result.payload))

  yield put(doPENDING_REQUEST_DELETE({requestType: REQUEST_METHOD_FETCH, requestId: payload.requestId}))

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_METHOD_FETCH,
        requestId: payload.requestId,
        ...result,
      },
      setRequestResult,
    ),
  )
}

export function* methodFetchSaga() {
  yield takeEvery(REQUEST_METHOD_FETCH, requestMethodFetch)
}
